import React from "react";

const CategoryPageSkeleton = () => {
  return (
    <div className="container mx-auto bg-white px-8 pb-32 pt-20 lg:pt-24">
      {/* Breadcrumb skeleton */}
      <div className="flex items-center">
        <nav className="text-base">
          <ol className="mb-4 list-none p-0 text-black">
            <li className="inline-block text-sm font-medium">
              <div className="h-4 w-12 animate-pulse rounded bg-gray-300"></div>
            </li>
            <li className="mx-2 inline-block text-[#6a707c]">/</li>
            <li className="inline-block text-black">
              <div className="h-4 w-24 animate-pulse rounded bg-gray-300"></div>
            </li>
          </ol>
        </nav>
      </div>

      {/* Header section skeleton */}
      <div className="flex flex-col items-center justify-between lg:flex-row">
        <div className="mb-8">
          <div className="mb-4 h-10 w-80 animate-pulse rounded bg-gray-300 md:h-12"></div>
          <div className="h-6 w-96 animate-pulse rounded bg-gray-300"></div>
        </div>

        {/* Category filter buttons skeleton */}
        <div className="mb-8 flex flex-wrap gap-3">
          {Array.from({ length: 6 }).map((_, index) => (
            <div
              key={index}
              className="h-10 w-24 animate-pulse rounded-md bg-gray-300"
            ></div>
          ))}
        </div>
      </div>

      {/* Content grid skeleton */}
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <div
            key={index}
            className="group relative overflow-hidden rounded-2xl bg-white transition-all duration-300"
          >
            {/* Image skeleton */}
            <div className="h-48 w-full animate-pulse rounded-t-2xl bg-gray-200 lg:h-56 xl:h-64 2xl:h-72"></div>

            {/* Content skeleton */}
            <div className="rounded-b-2xl border border-gray-200 p-4 lg:p-6">
              {/* Title skeleton */}
              <div className="mb-4">
                <div className="h-8 w-full animate-pulse rounded bg-gray-300"></div>
              </div>

              {/* Description skeleton */}
              <div className="mb-6 space-y-2">
                <div className="h-4 w-full animate-pulse rounded bg-gray-300"></div>
                <div className="h-4 w-full animate-pulse rounded bg-gray-300"></div>
                <div className="h-4 w-2/3 animate-pulse rounded bg-gray-300"></div>
              </div>

              {/* Read more link skeleton */}
              <div className="flex items-center">
                <div className="h-5 w-32 animate-pulse rounded bg-gray-300"></div>
                <div className="ml-2 h-4 w-4 animate-pulse rounded bg-gray-300"></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Loading indicator */}
      <div className="mt-8 flex justify-center">
        <div className="flex items-center space-x-2">
          <div className="h-2 w-2 animate-bounce rounded-full bg-gray-400"></div>
          <div
            className="h-2 w-2 animate-bounce rounded-full bg-gray-400"
            style={{ animationDelay: "0.1s" }}
          ></div>
          <div
            className="h-2 w-2 animate-bounce rounded-full bg-gray-400"
            style={{ animationDelay: "0.2s" }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default CategoryPageSkeleton;
